// A Block or Sub-block has no pillar of its own — it belongs to its Project's —
// so filtering by pillar walks up to the top ancestor. A parent missing from
// the list (not loaded) leaves the block unmatched rather than guessing.
export function projectPillarId<T extends { parent_id: string | null; pillar_id: string | null }>(
  block: T,
  byId: Map<string, T>
): string | null {
  let current = block;
  while (current.parent_id !== null) {
    const parent = byId.get(current.parent_id);
    if (parent === undefined) {
      return null;
    }
    current = parent;
  }
  return current.pillar_id;
}
